import React from "react";

import { AssociateContentFormContext } from "./AssociateContentFormContext";

export const useAssociateContentFormContext = () => {
    return React.useContext(AssociateContentFormContext);
};
